import { render, staticRenderFns } from "./SetupKafkaHarvester.vue?vue&type=template&id=0c1802e4&"
import script from "./SetupKafkaHarvester.vue?vue&type=script&lang=ts&"
export * from "./SetupKafkaHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports